import {
  PermissionContext,
  Post,
  PostAuthMemberProps,
  PostStatus,
  PostType,
  ReactionType,
  Space,
  SpaceType,
} from '@tribeplatform/gql-client/types'
import { Post as PostComponent } from '@tribeplatform/react-components/Post'
import { useAuthToken } from '@tribeplatform/react-sdk/hooks'

export function SamplePost() {
  const { data: authToken } = useAuthToken()
  const { member, network } = authToken || {}

  if (!member || !network) {
    return null
  }

  const now = new Date().toISOString()

  const space: Space = {
    id: 'sample-space-id',
    key: 'general',
    name: 'General',
    slug: 'general',
    layout: 'DEFAULT',
    networkId: network.id,
    type: SpaceType.Group,
    createdById: member.id,
    membersCount: 1,
    createdAt: now,
    updatedAt: now,
    customOrderingIndexInGroup: 1,
    address: {
      exact: false,
      path: 'general',
      editable: false,
    },
    highlightedTagIds: [],
  }

  const postType: PostType = network.postTypes.find(
    it => it.slug === 'discussion',
  )

  const authMemberProps: PostAuthMemberProps = {
    context: PermissionContext.POST,
    canReact: true,
    permissions: [
      {
        name: 'addReaction',
        isAuthorized: {
          authorized: true,
        },
        inputPermissions: [],
        outputPermissions: [],
      },
      {
        name: 'createReply',
        isAuthorized: {
          authorized: true,
        },
        inputPermissions: [],
        outputPermissions: [],
      },
    ],
    availableReplyTypes: [postType],
  }

  const author = {
    ...member,
    name: 'John Smith',
    profilePicture: undefined,
    badges: [],
  }

  const content =
    '"<p>John Smith joined us for a special Valentine’s Day webinar and shared how communities can foster a culture of appreciation and show love to the members ❤️</p>' +
    '<p><a href=\\"#\\">👉 Register for the upcoming webinar</a></p>"'

  const post: Post = {
    updatedAt: `${new Date().getUTCDate()}`,
    id: 'sample-post-id',
    slug: 'this-is-a-sample-post',
    fields: [
      {
        key: 'title',
        value: '"How Communities Show Love to Members"',
      },
      {
        key: 'content',
        value: content,
      },
    ],
    postTypeId: postType.id,
    reactionsCount: 0,
    hasMoreContent: false,
    isAnonymous: false,
    locked: false,
    shortContent: content,
    createdAt: now,
    ownerId: author.id,
    createdById: author.id,
    status: PostStatus.PUBLISHED,
    spaceId: space.id,
    imageIds: [],
    pollIds: [],
    pinnedInto: [],
    repliesCount: 0,
    totalRepliesCount: 0,
    repliedToId: null,
    title: 'This is a sample post',
    embedIds: [],
    mentionedMembers: [],
    primaryReactionType: ReactionType.LIKE_BASE,
    postType,
    owner: {
      member: author,
    },
    space,
    attachmentIds: [],
    negativeReactionsCount: 0,
    positiveReactionsCount: 0,
    networkId: network.id,
    topRepliers: [],
    singleChoiceReactions: [],
    seoDetail: {
      title: '',
    },
    authMemberProps,
  }

  return (
    <div className="cursor-default pointer-events-none">
      <PostComponent post={post} context="network" activeTagId="" view="card" />
    </div>
  )
}
